import { fetchData } from '../utils/data';
import { isLoggedIn } from '../persistance/storage';
import { requestHeaders } from './fetch-data';

import { INDEXING_STATUS } from '../constants/endpoints';
import {
  KEY,
  FETCH_INDEXING_STATUS,
  FETCH_INDEXING_STATUS_REQUEST,
  FETCH_INDEXING_STATUS_ERROR
} from '../constants/constants';

// Polls the indexing status without touching the global asyncAction state,
// so the page-level loading indicators are unaffected.
export function fetchIndexingStatus(){
  return dispatch => {
    const headers = requestHeaders(isLoggedIn(KEY));

    dispatch({ type: FETCH_INDEXING_STATUS_REQUEST });

    return fetchData(INDEXING_STATUS, headers)
      .then( data => dispatch({ type: FETCH_INDEXING_STATUS, data }) )
      .catch( error => dispatch({ type: FETCH_INDEXING_STATUS_ERROR, errMsg: error.message }) );
  };
}
